module.exports = __webpack_public_path__ + "a081e02e0e15d8686e0db9a5e2c97025.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/img-layout/bg-black-opacity.png
 ** module id = 537
 ** module chunks = 1
 **/